module.exports = __webpack_public_path__ + "static/pic03-cbc9cc5724c79974d1a858a76c3b537d.jpg";